import './index.styl';
import template from './index.jst';
import { View } from 'backbone.marionette';
import {
	TradePlayerPoolFilters,
	TradePlayerPoolList
} from '../../index';

import _ from 'lodash';


/**
 * @description Main view for PlayerPoolList and PlayerPoolFilters views.
 * Aggregate data and delegate work between views
 */
export class TradePlayerPool extends View {
	get template(){
		return template;
	}

	get tagName(){
		return 'section';
	}

	get className(){
		return 'trade-pool-list';
	}

	regions(){
		return {
			filters: '#trade-pool-filters',
			list: '#trade-pool-list'
		}
	}

	childViewTriggers() {
		return {
			'player:show:popup': 'player:show:popup'
		}
	}

	childViewEvents() {
		return {
			'filter:players': 'filterPlayersList',
		}
	}

	ui(){
		return {
			table_body: '#trade-pool-list',
		}
	}

	initialize(){
		this.getRegion('filters').show(new TradePlayerPoolFilters());
		this.getRegion('list').show(new TradePlayerPoolList());
	}

	filterPlayersList(filterRules) {

		filterRules = _.omitBy(filterRules, _.negate(_.identity));
		//commented out to allow filtering more filters 
		// if (filterRules.filter_by_name) {
		// 	filterRules = _.pick(
		// 		filterRules,
		// 		['is_asc_order', 'order_by', 'filter_by_name']
		// 	);
		// }

		this.getChildView('list').filterBy(filterRules);
	}

	onAttach() {
		const isEdge = window.navigator.userAgent.indexOf("Edge") > -1;
		const tableBody = this.ui.table_body[0];
		const headerScroll = document.querySelector('#header-with-scroll');
	
		if (!tableBody || !headerScroll) return;
	
		const forceRedraw = _.debounce(element => {
			if (!element) return;
			const n = document.createTextNode(' ');
			const disp = element.style.display;
			element.appendChild(n);
			element.style.display = 'none';
			element.style.display = disp;
			n.parentNode.removeChild(n);
		}, 250);
	
		let isSyncing = false;
	
		const syncScroll = (source, target) => {
			if (isSyncing) return;
			isSyncing = true;
	
			target.scrollLeft = source.scrollLeft;
			if (isEdge) forceRedraw(target);
	
			requestAnimationFrame(() => {
				isSyncing = false;
			});
		};
	
		// Listen to both scroll events
		tableBody.addEventListener('scroll', () => syncScroll(tableBody, headerScroll));
		headerScroll.addEventListener('scroll', () => syncScroll(headerScroll, tableBody));
	
		// Keep header logic working
		const childView = this.getChildView('filters');
		const scrollLeftHeader = childView.scrollLeftHeader.bind(childView);
	
		tableBody.addEventListener('scroll', e => {
			if (isEdge) forceRedraw(e.currentTarget);
			scrollLeftHeader(e.currentTarget.scrollLeft);
		});
	}
	

	onBeforeDestroy() {
		const tableBody = this.ui.table_body[0];
		const headerScroll = document.querySelector('#header-with-scroll');
	
		if (tableBody) {
			tableBody.removeEventListener('scroll', this._onTableScroll);
		}
	
		if (headerScroll) {
			headerScroll.removeEventListener('scroll', this._onHeaderScroll);
		}
	}
	
}

export default TradePlayerPool;